<template>
  <div id="conditionEdit">
    <div class="container">

      <div class="page-title">
        <span class="name">{{ $t('condition') }}</span>
      </div>

      <Tabs>
        <TabSection :title="$t('inventory.schedule')" collapsible>
          <div class="columns">
            <div class="column">
              <div class="group">
                <LocalizedInput :title="$t('name')" :translate="data.name" />
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <DayTimeRange :day="data.conditions.monday" dayName="monday" />
              <DayTimeRange :day="data.conditions.tuesday" dayName="tuesday" />
              <DayTimeRange :day="data.conditions.wednesday" dayName="wednesday" />
              <DayTimeRange :day="data.conditions.thursday" dayName="thursday" />
            </div>
            <div class="column">
              <DayTimeRange :day="data.conditions.friday" dayName="friday" />
              <DayTimeRange :day="data.conditions.saturday" dayName="saturday" />
              <DayTimeRange :day="data.conditions.sunday" dayName="sunday" />
            </div>
          </div>
        </TabSection>
      </Tabs>

      <div class="footer-actions" v-if="$store.getters.loggedUserCanModifyInventory">
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import DayTimeRange from '@/components/tools/DayTimeRange.vue';
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import { mapActions } from "vuex";

  export default {
    name: "ConditionEdit",

    components: { DayTimeRange, LocalizedInput },

    data() {
      return {
        inventory: null,
        data: {
          id: null,
          name: { fr: "", en: "" },
          conditions: {
            monday: { hours: [] },
            tuesday: { hours: [] },
            wednesday: { hours: [] },
            thursday: { hours: [] },
            friday: { hours: [] },
            saturday: { hours: [] },
            sunday: { hours: [] }
          }
        }
      }
    },

    computed: {
      company() {
        return this.$store.state.contextCompany;
      },
      inventoryReference() {
        return this.company ? this.company.nameCanonical : this.inventory.id;
      },
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.schedules";
      this.$store.state.pageIcon = "/icon/menu.svg";

      this.$store.commit("showSpinner", true);
      this.conditionId = this.$route.query.condition;
      this.inventory = await this.$store.getters.getContextInventory;

      if (this.conditionId) {
        let data = await this.getOneInventoryEntity({ entity: 'conditions', inventory: this.inventoryReference, id: this.conditionId });
        if (data) {
          Object.assign(this.data, data);
        }
        this.$store.commit("showSpinner", false);
      } else {
        this.$store.commit("showSpinner", false);
      }

      if (this.$store.getters.isBranchContextInventory) {
        window.lockFields(this.$store.getters.getOverloadableFields);
      } else if (!this.$store.getters.loggedUserCanModifyInventory) {
        window.lockFields();
      }
    },

    watch: {
      "$store.getters.isBranchContextInventory"(newValue) {
        if (newValue) {
          window.lockFields(this.$store.getters.getOverloadableFields);
        }
      }
    },

    methods: {
      ...mapActions(["getOneInventoryEntity", "saveInventoryEntity", "createInventoryEntity"]),

      async save() {
        this.$store.commit("showSpinner", true);
        let response = this.conditionId
          ? this.saveInventoryEntity({ entity: 'conditions', inventory: this.inventoryReference, data: this.data, id: this.conditionId })
          : this.createInventoryEntity({ entity: 'conditions', inventory: this.inventoryReference, data: this.data });

        if (response) {
          this.$router.push(this.$router.buildContext("/inventory_hours"));
          toast(this.$t("inventory_hours.success"), "success");
        } else {
          toast(this.$t("inventory_hours.error.save"), "error");
        }
        this.$store.commit("showSpinner", false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  #conditionEdit {
    display: flex;
  }
</style>